import {
  fetchUserRepo,
  getCreateUserRepo,
  postCreateUserRepo,
  postValidateFieldsRepo,
} from "../../repositories/user/user";
import { createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";

const userSlice = createSlice({
  name: "userReducer",
  initialState: {
    loading: null,
    user: null,
    user_error: null,
    createUserLoading: null,
    createUser: null,
    createUserError: null,
    postCreateUserResponse: null,
    postCreateUserError: null,
    validateLoading: null,
    validate: null,
    validateError: null,
  },
  reducers: {
    Loading(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    setUserInState(state, action) {
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    },
    tokenError(state, action) {
      return {
        ...state,
        loading: false,
        user: null,
        user_error: action.payload,
      };
    },
    getCreateUserLoading(state, action) {
      return {
        ...state,
        createUserLoading: true,
      };
    },
    getCreateUserSuccess(state, action) {
      return {
        ...state,
        createUserLoading: false,
        createUser: action.payload,
      };
    },
    getCreateUserFailure(state, action) {
      return {
        ...state,
        createUserLoading: false,
        createUserError: action.payload,
      };
    },
    postCreateUserSuccess(state, action) {
      return {
        ...state,
        postCreateUserResponse: action.payload,
      };
    },
    postCreateUserFailure(state, action) {
      return {
        ...state,
        postCreateUserError: action.payload,
      };
    },
    clearPostCreateUserSuccess(state, action) {
      return {
        ...state,
        postCreateUserResponse: null
      };
    },
    validatesRequest(state, action) {
      return {
        ...state,
        validateLoading: true,
      };
    },
    validateSuccess(state, action) {
      return {
        ...state,
        validateLoading: false,
        validate: action.payload,
      };
    },
    validateFailure(state, action) {
      return {
        ...state,
        validateLoading: false,
        validate: null,
        validateError: action.payload,
      };
    },
  },
});
export const {
  Loading,
  setUserInState,
  tokenError,
  getCreateUserLoading,
  getCreateUserSuccess,
  getCreateUserFailure,
  postCreateUserSuccess,
  postCreateUserFailure,
  clearPostCreateUserSuccess,
  validatesRequest,
  validateSuccess,
  validateFailure,
} = userSlice.actions;

export const fetchUser = (params) => {
  const cookies = new Cookies();
  let sessionKey = ''

  Object.keys(cookies.getAll())?.map((value, index) => {
    if (value?.includes("SESS") && !value?.includes("CSESS360"))
      sessionKey = value
  })
  const sessionValue = cookies.get(sessionKey)
  return (dispatch) => {
    dispatch(Loading(false));
    fetchUserRepo(sessionValue)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(setUserInState(response?.data));
        }
      })
      .catch((error) => {
        dispatch(tokenError("User Not Authenticated"));
      });
  };
};

export const getCreateUser = (params) => {
  return (dispatch) => {
    dispatch(getCreateUserLoading());
    getCreateUserRepo(params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(getCreateUserSuccess(response?.data?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCreateUserFailure(error.message));
        }
      });
  };
};

export const postCreateUser = (data, params) => {
  return (dispatch) => {
    postCreateUserRepo(data, params)
      .then((response) => {
        if (response?.status == 200) {
          dispatch(postCreateUserSuccess(response?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postCreateUserFailure(error.message));
        }
      });
  };
};
export const postValidateFields = (data) => {
  return (dispatch) => {
    dispatch(validatesRequest(false));
    postValidateFieldsRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(validateSuccess(response?.data));
        } else {
          dispatch(validateFailure(response?.message));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(validateFailure(error?.message));
        }
      });
  };
};
export default userSlice.reducer;
